import { useEffect, useCallback, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

export const useResizeObserver = ({ callback, observeOptions }) => {
    const [observer, setObserver] = useState(null);

    useEffect(() => {
        const resizeObserver = new ResizeObserver(callback);

        setObserver(resizeObserver);

        return () => {
            resizeObserver.disconnect();
        };
    }, [callback]);

    return useCallback((node) => {
        if (node && observer) {
            observer.observe(node, observeOptions);
        }
    }, [observer, observeOptions]);
};
